import React from 'react';

import { healthQuestionTypes, collectAnswersTypes } from './actions'

const initialState = {
    isFetching: false,
    results: {},
    data: {},
    groups: {},
    answeredQuestions: {},
    questionAccountant: {}
}


const processQuestions = (data, insuranceName, questionAccountant) => {
    let results = data.questions
    if(data.questions !== null) {
        data.questions.map((question_block) => {
            question_block.value.question_groups.map((qg) => {
                if (qg.questions.length > 0) {
                    qg.questions.map(q => {
                        let lookup = q.id
                        if (q.value.product_aware) {
                            // if the question is marked as product aware, it is not copied between products, even if the question is the same between products
                            lookup = `${lookup}-${insuranceName}`
                        }
                        if(questionAccountant[lookup] === undefined ) {
                            questionAccountant[lookup] = [insuranceName]
                        } else {
                            if(!questionAccountant[lookup].indexOf(insuranceName) > -1) {
                                var joined = questionAccountant[lookup].concat(insuranceName);
                                questionAccountant[lookup] = joined;
                            }
                        }
                        
                    })
                }
            })
        })
    }
    return {results: results, questionAccountant: questionAccountant}
}


export function healthQuestions(state = initialState, action) {

    switch (action.type) {

        case healthQuestionTypes.REQUEST:
            state = { ...state, isFetching: true, }
            state.isFetching = true
            
            return state


        case healthQuestionTypes.RECEIVE:
            state = { ...state, isFetching: false }
            if(Array.isArray(action.data)) {
                action.data.map(hq => {
                    let processed = processQuestions(hq, hq.lookup_code, state.questionAccountant)
                    processed.results.addtionalQuestionsList = hq.addtional_questions_list 
                    state.results[hq.lookup_code] = processed.results
                    state.questionAccountant = processed.questionAccountant
                }) 
            } else {
                let processed = processQuestions(action.data, action.insuranceName, state.questionAccountant)
                processed.results.addtionalQuestionsList = action.data.addtional_questions_list 
                state.results[action.insuranceName] = processed.results
                state.questionAccountant = processed.questionAccountant 
            }
            // state.results[action.insuranceName] = action.data.questions
            // if(action.data.questions !== null) {
            //     action.data.questions.map((question_block) => {
            //         question_block.value.question_groups.map((qg) => {
            //             if (qg.questions.length > 0) {
            //                 qg.questions.map(q => {
            //                     if(state.questionAccountant[q.id] === undefined ) {
            //                         state.questionAccountant[q.id] = [action.insuranceName]
            //                     } else {
            //                         if(!state.questionAccountant[q.id].indexOf(action.insuranceName) > -1) {
            //                             var joined = state.questionAccountant[q.id].concat(action.insuranceName);
            //                             state.questionAccountant[q.id] = joined;
            //                         }
            //                     }
                                
            //                 })
            //             }
            //         })
            //     })
            // }

            return state

        case collectAnswersTypes.SET_ANSWER:
            state = { ...state }
            if(state.data[action.customerId] === undefined) {
                state.data[action.customerId] = {
                    [action.insuranceName]: {
                        [action.key]: action.value
                    }
                }
            } else {
                if (state.data[action.customerId][action.insuranceName] === undefined) {
                    state.data[action.customerId][action.insuranceName] = {
                        [action.key]: action.value
                    }
                } else {
                    state.data[action.customerId][action.insuranceName][action.key] = action.value
                }
            }

            if (action.value === "" || action.value.length === 0) {
                delete state.data[action.customerId][action.insuranceName][action.key]
            }

            if(state.groups[action.customerId] === undefined) {
                state.groups[action.customerId] = {
                    [action.insuranceName]: {
                        [action.groupTitle] : {
                            [action.subgroup]: {
                                [action.key]: action.value
                            }
                        }
                    }
                }
            } else {
                if (state.groups[action.customerId][action.insuranceName] === undefined) {
                    state.groups[action.customerId][action.insuranceName] = {
                        [action.groupTitle]: {
                            [action.subgroup]: {
                                [action.key]: action.value
                            }
                        }
                    }
                } else {
                    if (state.groups[action.customerId][action.insuranceName][action.groupTitle] === undefined) {
                        state.groups[action.customerId][action.insuranceName][action.groupTitle] = {
                            [action.subgroup] : {
                                [action.key]: action.value
                            }
                        }
                    } else {
                        if (state.groups[action.customerId][action.insuranceName][action.groupTitle][action.subgroup] === undefined) {   
                            state.groups[action.customerId][action.insuranceName][action.groupTitle][action.subgroup] = {
                                [action.key]: action.value
                            }
                        } else {
                            state.groups[action.customerId][action.insuranceName][action.groupTitle][action.subgroup][action.key] = action.value
                        }
                    }
                }
            }

            if (action.value === "" || action.value.length === 0) {
                delete state.groups[action.customerId][action.insuranceName][action.groupTitle][action.subgroup][action.key]
            }

            return state

        case collectAnswersTypes.DELETE_ANSWER:
            state = { ...state }
            if (state.data[action.customerId][action.insuranceName][action.key]) {
                delete state.data[action.customerId][action.insuranceName][action.key]
                delete state.groups[action.customerId][action.insuranceName][action.insuranceName][action.infoType][action.key]
                if (Object.keys(state.data[action.customerId][action.insuranceName]).length == 0) {
                    delete state.data[action.customerId][action.insuranceName]
                }
                if (Object.keys(state.groups[action.customerId][action.insuranceName][action.insuranceName][action.infoType]).length === 0) {
                    delete state.groups[action.customerId][action.insuranceName][action.insuranceName][action.infoType]
                }
                if (Object.keys(state.groups[action.customerId][action.insuranceName][action.insuranceName]).length === 0) {
                    delete state.groups[action.customerId]
                }
            }
            return state

        case collectAnswersTypes.EXPORT_ANSWERED_QUESTIONS:
            state = { ...state }

            if(state.answeredQuestions[action.customerId] === undefined) {
                state.answeredQuestions[action.customerId] = {
                    [action.insuranceName]: {
                        [action.group.title] : action.questions
                    }
                }
            } else {
                if (state.answeredQuestions[action.customerId][action.insuranceName] === undefined) {
                    state.answeredQuestions[action.customerId][action.insuranceName] = {
                        [action.group.title]: action.questions                               
                    }
                } else {
                    if (state.answeredQuestions[action.customerId][action.insuranceName][action.group.title] === undefined) {
                        state.answeredQuestions[action.customerId][action.insuranceName][action.group.title] = action.questions
                    } else {
                        state.answeredQuestions[action.customerId][action.insuranceName][action.group.title] = action.questions
                    }
                }
            }            
            return state

        default:
            return state
    }
}